export enum ProcessType {
  MERGE_PURGE = "merge-purge"
}
